<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card style="background-color: #EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>
            {{ json_data.save_type == 'create' ? $t('menu.CreateIndividualPermissionsList') : $t('menu.EditIndividualPermissionsList')
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout
              row
              wrap
              pa-4
              style="background-color:#fff; margin-top:5px; border-radius:5px;"
            >
              <!-- <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('group_number')"
                        append-icon="fas fa-plus-circle"
                        hide-details
                        :readonly="json_data.save_type == 'create'"
                        v-model="form_model.group_code"
                        :rules="form_rules.group_code"
                        required
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field
                        :label="$t('groupname')"
                        v-model="form_model.group_name"
                        :rules="form_rules.group_name"
                      />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>-->
              <v-layout row wrap style="margin-bottom:20px">
                <h3>{{form_model.code}} &nbsp;{{form_model.first_name}}&nbsp;{{form_model.last_name}}</h3>
              </v-layout>
              <v-flex xs12>
                <v-layout md6 sm6 xs12 pa-1>
                  <v-flex xs12 md12 sm12 style="max-height: 70vh; border-radius: 5px; box-shadow: 2px 2px 4px #CFD8DC;" class="scroll-able">
                    <table
                      id="table_detail"
                      class="table table-borderless sticky-table"
                      style="height:300px !important;overflow: auto;"
                    >
                      <thead>
                        <tr style="color: #fff">
                          <th nowrap style="width: 70%"><span>{{$t('menu_list')}}</span></th>
                          <th nowrap style="width: 10%">
                            <span>{{$t('all')}}</span>
                          </th>
                          <th nowrap style="width: 10%"><span>{{$t('edit')}}</span></th>
                          <th nowrap style="width: 10%"><span> {{$t('view')}}</span></th>
                        </tr>
                      </thead>
                      <tbody
                        v-for="(item, index) in topic "
                        :key="index"
                        @click="''"
                        style="vertical-align: middle;"
                      >
                        <tr>
                          <td nowrap colspan="4" style="background-color: #4DB6AC">
                           <p
                              style="
                                font-size: 1rem;
                                margin-top: 10px;
                                color: #fff;
                              "
                            >
                              <strong>{{ $t("menu." + index) }}</strong>
                            </p>
                          </td>
                        </tr>
                        <tr v-for="(sub, i) in item" :key="i">
                          <td nowrap>
                            <p>- - &nbsp;{{$t("menu."+sub.module_name)}}</p>
                          </td>
                          <td nowrap>
                            <v-checkbox
                              v-model="sub.full_control"
                              class="mx-2"
                              color="info"
                              @change="selectAll(sub)"
                            ></v-checkbox>
                          </td>
                          <td nowrap>
                            <v-checkbox v-model="sub.edit" class="mx-2" color="success" @change="selectSome(sub)"></v-checkbox>
                          </td>
                          <td nowrap>
                            <v-checkbox
                              v-model="sub.reads"
                              class="mx-2"
                              color="success"
                              @change="selectSome(sub)"
                            ></v-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn
                color="success"
                @click="json_data.save_type == 'create' ? onSave() : onUpdate()"
              >
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";
import EmployeeService from "@/services/EmployeeService";
export default {
  props: {
    json_data: Object
  },
  watch: {
    async json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
        await this.getPermissionbyEmp();
        console.log("code", this.form_model.code);
      } else {
        //this.$refs.form.resetValidation();
        this.doNewGuid();
      }
    }
  },
  data: () => ({
    branch_list: [],
    form_valid: false,
    form_model: {
      code: "",
      name: "",
      remark: "",
      branchCode: "",
      editorCode: localStorage._usercode,
      plan_code: ""
    },
    form_rules: {
      code: [v => !!v || "do not empty."],
      branchCode: [v => !!v || "do not empty."],
      name: [v => !!v || "do not empty."]
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    profilePlan: [],
    table_module: [
      {
        group: "EmployeeList",
        module_name: "EmployeeList",
        edit: false,
        reads: false
      },
      {
        group: "Employeeinactive",
        module_name: "Employeeinactive",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile",
        module_name: "ImportFileIncome",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile",
        module_name: "ImportFileExpensed",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile",
        module_name: "ImportFingerScan",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ExpensedAndIncomeList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "CheckInOutList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "TakeLeaveList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ChangePlanList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "OTPlanList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ReSignList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "ChangeSalaryList",
        edit: false,
        reads: false
      },
      {
        group: "เพิ่มเอกสารร้องขอ",
        module_name: "CommissionList",
        edit: false,
        reads: false
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "ChangeWorkplanList",
        edit: false,
        reads: false
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "CheckInList",
        edit: false,
        reads: false
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "TimeCheckList",
        edit: false,
        reads: false
      },
      {
        group: "แผนงานและเวลาทำงาน",
        module_name: "WorkPlanByEMPList",
        edit: false,
        reads: false
      },
      {
        group: "เงินเดือนและการจ่ายเงิน",
        module_name: "SalaryTableList",
        edit: false,
        reads: false
      },
      {
        group: "เงินเดือนและการจ่ายเงิน",
        module_name: "PayRollDocumentList",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "HolidayList",
        edit: false,
        reads: false
      },
      // {
      //   group: "ตั้งค่าทั่วไป",
      //   module_name: "HolidayInYear",
      //   full_control: false,
      //   edit: false,
      //   reads: false
      // },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "BranchList",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "DepartmentList",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "WorkPlanList",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "ConditionsList",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "CompanyAddress",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "GeneralSetting",
        edit: false,
        reads: false
      },
      {
        group: "ตั้งค่าทั่วไป",
        module_name: "TaxSettingList",
        edit: false,
        reads: false
      },
       {
        group: "ตั้งค่าทั่วไป",
        module_name: "DeviceSettingList",
        edit: false,
        reads: false
      },
       {
        group: "ตั้งค่าทั่วไป",
        module_name: "MappingDeviceSettingList",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportEmployee",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportDepartment",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportBranch",
        edit: false,
        reads: false
      },
      {
        group: "ImportFile_Master",
        module_name: "ImportHoliday",
        edit: false,
        reads: false
      },
      {
        group: "Permissions",
        module_name: "IndividualPermissionsList",
        edit: false,
        reads: false
      },
      {
        group: "Permissions",
        module_name: "GroupPermissionsList",
        edit: false,
        reads: false
      }
    ],
    form_json: {
      emp_code: "",
      permission: []
    },
    topic: [],
    detail_module: []
  }),
  methods: {
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    clearForm() {
      this.topic = [];
      this.form_json = {
        emp_code: "",
        permission: []
      };
    },
    doNewGuid() {
      this.form_model.code = Utils.newGuid("D");
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    // getProfileBranchList() {
    //   SettingService.getProfileBranchList()
    //     .then(res => {
    //       this.branch_list = res.data.content;
    //     })
    //     .catch(err => {
    //       this.showSnackBar(err.response.data, "error");
    //     });
    // },
    onSave() {
      
     // console.log(this.table_module.length);
    //  console.log("onsave detail_module:", this.detail_module);
      this.form_json.emp_code = this.json_data.data.code;
      this.detail_module.forEach(el => {
        this.form_json.permission.push({
          group: el.group,
          module_name: el.module_name,
          edit: el.edit,
          reads: el.reads
        });
      });
     // console.log("table model", this.form_json);
      EmployeeService.CreateEmpPermission(this.form_json)
        .then(res => {
          this.showSnackBar("save success", "success");
          //this.getPermissionbyEmp();
          this.closeDialog();
        })
        .catch(err => {
          this.showSnackBar(err.response.data, "error");
        });
    },
    onUpdate() {
      //console.log("onUpdate detail_module:", this.detail_module);
      this.form_json.emp_code = this.json_data.data.code;
      this.detail_module.forEach(el => {
        this.form_json.permission.push({
          group: el.group,
          module_name: el.module_name,
          edit: el.edit,
          reads: el.reads
        });
      });

     // console.log("update: ", this.form_json);
      EmployeeService.CreateEmpPermission(this.form_json)
        .then(res => {
          this.showSnackBar("update success", "success");
          this.closeDialog();
        })
        .catch(err => {
          this.showSnackBar(err.response.data, "error");
        });
    },
    selectAll(item) {
     // console.log("selectall : " + item.full_control);
      if(item.full_control){
        item.reads = true;
        item.edit =true;
      }else{
         item.reads = false;
        item.edit =false;
      }
    },
    selectSome(item) {
      if(item.edit && item.reads){
        item.full_control = true;
       
      }else{
        item.full_control = false;
      }
    },
    duplicateArray(arr) {
      const return_arr = [];
      let role;
      this.table_module.forEach(el1 => {
        role = arr.filter(array => {
          return array.module_name == el1.module_name;
        });
        console.log(role[0])
        if (role.length > 0) {
          return_arr.push(role[0]);
        }
      });

      return return_arr;
    },

    comparer(array) {
      return current_Arr => {
        return (
          array.filter(arr => {
            return arr.module_name == current_Arr.module_name;
          }).length == 0
        );
      };
    },

    checkfullcontrol(arr){
      var checkfull = [];
        arr.forEach(element => {
          if(element.reads == true && element.edit == true){
            checkfull.push({
              group: element.group, 
              reads: element.reads, 
              edit: element.edit, 
              full_control: true,
              module_name: element.module_name
            })
              
          }else{
            checkfull.push({
              group: element.group, 
              reads: element.reads, 
              edit: element.edit, 
              full_control: false,
              module_name: element.module_name
            })
          }
        });
        
        return checkfull
    },
    checktimeatt(arr){
      var checktiime_arr = [];
      var time = localStorage._is_timeattendance;
      if(time == 0){
        arr.forEach(item => {
           if (item.group!='แผนงานและเวลาทำงาน' && item.module_name !='ImportFingerScan' &&item.module_name !="CheckInOutList" && item.module_name !="TakeLeaveList" && item.module_name !="ChangePlanList" && item.module_name !="OTPlanList" &&  item.module_name !="WorkPlanList" && item.module_name !="ConditionsList" && item.module_name != "DeviceSettingList" && item.module_name != "MappingDeviceSettingList") {
             checktiime_arr.push(item);
           }
        });
      }else{
        checktiime_arr = arr;
      }
      return checktiime_arr
    },

    getPermissionbyEmp() {
      EmployeeService.getPermissionbyEmp(this.form_model.code)
        .then(res => {
          if (res.data != null) {
            var arr1 = this.table_module.filter(
              this.comparer(res.data.permission)
            );
            var arr2 = this.duplicateArray(res.data.permission);
            this.detail_module = this.checktimeatt(this.checkfullcontrol(arr2.concat(arr1)));
             console.log(this.detail_module);
            this.topic = this.groupBy(this.detail_module, "group");
          } else {
            this.detail_module = this.checktimeatt(this.checkfullcontrol(this.table_module));
            this.topic = this.groupBy(this.detail_module, "group");
          }
        })
        .catch(err => {
          this.detail_module = this.checktimeatt(this.checkfullcontrol(this.table_module));
          this.topic = this.groupBy(this.detail_module, "group");
        });
    },
    groupBy(arr, key) {
      const result = {};
      arr.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    }
  }
};
</script>
<style>
.v-card__text {
  padding: 0px !important ;
}
.sticky-table th {
  background-color: #009688;
  position: sticky;
  top: 0;
  z-index: 1;
}
th {
  text-align: left;
}
</style>